import HikSetDriverVehicleinfoModal from './hik-set-driver-vehicleinfo-modal.vue'
export default HikSetDriverVehicleinfoModal
